import { ITheme } from "../../utils/theme";

export const ArrowBtnStyle = {
  borderRadius: 0,
  p: 0,
};

export const titleWrapper = (theme: ITheme) => ({
  cursor: 'pointer',
  display: 'flex',
  flexDirection: 'row',
  borderBottom: `1px solid ${theme.palette.grey[100]}`,
});
